export const resolveAllPromises = async (promises: Promise<any>[]): Promise<any> => {
  const promisesRes = await Promise.all(await promises)
  return Promise.resolve(promisesRes)
}
